export const isItDemoAccount = (email: string) => {
  const hasDemoFormat = RegExp(/^demo[0-9]+\+.+@everlance\.com$/).test(email)
  const match = email.match(/\d+/)
  if (hasDemoFormat === false || match === null) return false
  const demoAccountNumber = Number(match[0])
  if (demoAccountNumber < 1 || demoAccountNumber > 50) return false
  return true
}

export const isItDemoAdminAccount = (email: string) =>
  RegExp(/^demo[0-9]+\+admin@everlance\.com$/).test(email)

export const SALES_DEMO_JOB_ID = 'sales_demo_job_id'
